// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__zlJPv","label":"Labeled_label__2XjPr","divider":"Labeled_divider__2JzfX"};